import React, { useEffect, useRef, useState } from 'react'
import { addPendingAffiliatesConfig } from './AddPendingAffiliate.formfield.config';
import FormCreator from '../../../../../../../components/finalForms/FormCreator';
import Buttons from '../../../../../../../components/ui/button/Buttons';
import { useAddPendingContractAffiliateMutation, useGetActiveClientsMutation } from '../../../../../../../app/services/pendingContractAPI';
import { setFieldSetting } from '../../../../../../../utils/formFieldUtils/ManageFields';
import { FieldSettingType } from '../../../../../../../components/finalForms/libs/data/fieldSettingType';
import { setDropdownOptions } from '../../../../../../../components/finalForms/libs/data/mapDropdownOptions';
import ToastService from '../../../../../../../services/toastService/ToastService';
import { useLazyGetAllDepartmentsQuery } from '../../../../../../../app/services/departmentAPI';

const AddPendingAffiliate = ({ isOpen, pendingContractId, onClose, getList }) => {
    const AddPendingAffiliatesRef = useRef();
    const [pendingAffiliateForm, setPendingAffiliateForm] = useState(addPendingAffiliatesConfig);

    const [getActiveClients, {
        isFetching: getActiveClientsFetching,
        isSuccess: getActiveClientsFetched,
        data: getActiveClientsData,
    },] = useGetActiveClientsMutation();

    const [getPendingContractDepartments, {
        isFetching: getPendingContractDepartmentsFetching,
        isSuccess: getPendingContractDepartmentsFetched,
        data: getPendingContractDepartmentsData,
    },] = useLazyGetAllDepartmentsQuery();

    const [addPendingContractAffiliate, {
        isFetching: addPendingContractAffiliateFetching,
        isSuccess: addPendingContractAffiliateFetched,
        data: addPendingContractAffiliateData,
    },] = useAddPendingContractAffiliateMutation();

    useEffect(() => {
        const request = {
            pbIncludeNone: true,
            plClientKeyToInclude: null,
        };
        getActiveClients(request);
        setFieldSetting(pendingAffiliateForm, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    useEffect(() => {
        if (!getActiveClientsFetching && getActiveClientsFetched && getActiveClientsData) {
            setDropdownOptions(getActiveClientsData, 'lClientKey', 'sClientName1', pendingAffiliateForm, 'lClientKey', setPendingAffiliateForm);
            setFieldSetting(pendingAffiliateForm, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getActiveClientsFetching, getActiveClientsFetched, getActiveClientsData]);

    useEffect(() => {
        if (!getPendingContractDepartmentsFetching && getPendingContractDepartmentsFetched && getPendingContractDepartmentsData) {
            setDropdownOptions(getPendingContractDepartmentsData, 'lDepartmentKey', 'sDepartmentName', pendingAffiliateForm, 'lDepartmentKey', setPendingAffiliateForm);
            setFieldSetting(pendingAffiliateForm, 'lDepartmentKey', FieldSettingType.ISFIELDDATALOADING, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getPendingContractDepartmentsFetching, getPendingContractDepartmentsFetched, getPendingContractDepartmentsData]);


    useEffect(() => {
        if (addPendingContractAffiliateFetched && addPendingContractAffiliateData) {
            if (addPendingContractAffiliateData) {
                ToastService.success(addPendingContractAffiliateData?.errorMessage);
                getList();
                onClose();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addPendingContractAffiliateFetched, addPendingContractAffiliateData]);


    const handleFieldChange = (dataField, updatedFormData) => {

        const plClientKey = updatedFormData.lClientKey;

        const selectedClient =
            plClientKey && typeof plClientKey === "object" ? plClientKey.value : plClientKey;

        if (dataField === "lClientKey") {

            const req = {
                plDepartmentKey: 0,
                plClientKey: selectedClient,
                pbIncludeInactive: false,
            };

            getPendingContractDepartments(req);

            let form = { ...addPendingAffiliatesConfig }

            form.initialState = {
                ...updatedFormData,
                lClientKey: selectedClient,
                lDepartmentKey: null,
            }
            setPendingAffiliateForm(form);

            return;
        }
    };


    const extractValue = (field) => {
        return field && typeof field === "object" ? field.value : field;
    };

    const handleSave = () => {
        const formData = AddPendingAffiliatesRef.current.getFormData();
        const requestData = {
            plPendingContractKey: pendingContractId,
            plDepartmentKey: extractValue(formData.lDepartmentKey),
        };

        addPendingContractAffiliate(requestData);
    }
    return (
        <>
            <div className="row">
                <FormCreator ref={AddPendingAffiliatesRef} config={pendingAffiliateForm}
                    onColumnChange={handleFieldChange}
                />
                <div className="d-flex justify-content-end gap-3 mt-3">
                    <Buttons
                        buttonText="Save"
                        buttonTypeClassName="btn blue-btn"
                        titleText="Unassign Selected Items"
                        onClick={handleSave}
                        isLoading={addPendingContractAffiliateFetching}
                    />
                    <Buttons
                        buttonText="Cancel"
                        buttonTypeClassName="btn dark-btn"
                        titleText="Unassign Selected Items"
                        onClick={onClose}
                    />
                </div>
            </div>
        </>
    );
}

export default AddPendingAffiliate